import { FinalCtaSection } from "./FinalCtaSection";
import { FlowOverviewSection } from "./FlowOverviewSection";
import { FooterSection } from "./FooterSection";
import { FounderMessageSection } from "./FounderMessageSection";
import { HeroSection } from "./HeroSection";
import "./landing.css";
import { PricingSection } from "./PricingSection";
import { ProblemSection } from "./ProblemSection";
import { Step1PersonaSection } from "./Step1PersonaSection";
import { Step2SkillSection } from "./Step2SkillSection";
import { Step3MailSection } from "./Step3MailSection";
import { Step4MeasurementSection } from "./Step4MeasurementSection";
import { Step4OperationsSection } from "./Step4OperationsSection";
import { TopNavBar } from "./TopNavBar";

export function LandingPage() {
  return (
    <div className="lp-root bg-white">
      <TopNavBar />
      <main>
        <HeroSection />
        <FlowOverviewSection />
        <ProblemSection />
        <Step1PersonaSection />
        <Step2SkillSection />
        <Step3MailSection />
        <Step4OperationsSection />
        <Step4MeasurementSection />
        <FounderMessageSection />
        <PricingSection />
        <FinalCtaSection />
      </main>
      <FooterSection />
    </div>
  );
}
